export default __webpack_public_path__ + "static/media/31.c0b290ed.jpg";